export function registerServiceWorker() {
    if (!('serviceWorker' in navigator)) return;
    if (window.location.hostname === 'localhost') return;
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js').catch(() => {});
    });
}
